import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { Route } from '../route';
import { submitter } from '../submitter/submitter';
import { BaseMetric } from './base-metric';
export var Metric = /*#__PURE__*/function (_BaseMetric) {
  function Metric() {
    _classCallCheck(this, Metric);
    return _callSuper(this, Metric, arguments);
  }
  _inherits(Metric, _BaseMetric);
  return _createClass(Metric, [{
    key: "start",
    value: function start() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        startTime = _ref.startTime;
      _superPropGet(Metric, "start", this, 3)([{
        startTime: startTime
      }]);
      this.route = Route.getRoute();
    }
  }, {
    key: "stop",
    value: function stop() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stoppedSuccessfully = _superPropGet(Metric, "stop", this, 3)([params]);
      if (stoppedSuccessfully && !this.config.virtual) {
        submitter.queue(this.getData());
      }
      return stoppedSuccessfully;
    }
  }]);
}(BaseMetric);